/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
import { useContext, createContext } from 'react';
import { WorkspaceExampleWithId } from '../../customTypes';

export interface WorkspaceExamplesContextApi {
  workspaceExamples: WorkspaceExampleWithId[];
  getWorkspaceExample: (workspaceExampleId?: string | null) => WorkspaceExampleWithId | undefined;
}

const initialState: WorkspaceExamplesContextApi = {
  workspaceExamples: [],
  getWorkspaceExample: () => undefined,
};

export const WorkspaceExamplesContext = createContext<WorkspaceExamplesContextApi>(initialState);

export const useWorkspaceExamplesContext = () => useContext(WorkspaceExamplesContext);